import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import { Component, Vue } from 'vue-property-decorator';

export default class AuthService {
  private userManager: UserManager;

  constructor() {
    // console.log(process.env.NODE_ENV);
    const STS_DOMAIN: string = process.env.VUE_APP_IDP_URL;
    const settings: any = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: STS_DOMAIN,
      client_id: process.env.VUE_APP_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_BASE_URL + '/callback.html',
      automaticSilentRenew: true,
      silent_redirect_uri: process.env.VUE_APP_BASE_URL + '/silent-renew.html',
      response_type: 'code',
      scope: 'openid profile UVApi',
      post_logout_redirect_uri: process.env.VUE_APP_BASE_URL + '/',
      filterProtocolClaims: true
    };
    // console.log(STS_DOMAIN);
    this.userManager = new UserManager(settings);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public getAccessToken(): Promise<string> {
    return this.userManager.getUser().then((data: any) => {
      if (data !== null) {
        return data.access_token;
      } else {
        return '';
      }
    });
  }
}
